import { createAction, props, union } from '@ngrx/store';

import { LocalDate } from '@fcom/core/utils';
import { DeepLinkSource } from '@fcom/common/interfaces';
import { FinnairAlternativeOffers, FinnairOrder, FinnairSelfReacConfirmationResponse } from '@fcom/dapi/api/models';

import { AlternativeOffersStateStatus, BookingInfo, Stage } from '../../interfaces';

export const reset = createAction('[AlternativeOffers] Reset');

export const setOffers = createAction(
  '[AlternativeOffers] Set',
  props<{ boundIndex: number; alternativeOffers: FinnairAlternativeOffers }>()
);
export const resetOffers = createAction('[AlternativeOffers] ResetOffers');

export const setDisruptedBoundIndex = createAction(
  '[DisruptedBoundIndex] Set',
  props<{ disruptedBoundIndex: number }>()
);

export const setShowAlternativeOffers = createAction(
  '[AlternativeOffers] SetShowAlternativeOffers',
  props<{ show: boolean }>()
);

export const setStatus = createAction(
  '[AlternativeOffers] SetStatus',
  props<{ status: AlternativeOffersStateStatus }>()
);

export const setSelectedOffer = createAction(
  '[AlternativeOffers] SetSelectedOffer',
  props<{ boundIndex: number; id: string }>()
);
export const resetSelectedOffers = createAction('[AlternativeOffers] ResetSelectedOffers');

export const setSelectedDate = createAction(
  '[AlternativeOffers] SetSelectedDate',
  props<{ boundIndex: number; date: LocalDate }>()
);

export const setStage = createAction('[AlternativeOffers] setStage', props<{ stage: Stage }>());

export const setDeeplinkSource = createAction(
  '[AlternativeOffers] setDeeplinkSource',
  props<{ source: DeepLinkSource }>()
);
export const resetDeeplinkSource = createAction('[AlternativeOffers] resetDeeplinkSource');
export const setConfirmationResponse = createAction(
  '[AlternativeOffers] setConfirmationResponse',
  props<{ confirmationResponse: FinnairSelfReacConfirmationResponse }>()
);

export const setSessionExpired = createAction('[AlternativeOffers] setSessionExpired');

export const setSessionStarted = createAction(
  '[AlternativeOffers] setSessionStarted',
  props<{ sessionStartedMs: number }>()
);

export const setBooking = createAction('[AlternativeOffers] setBooking', props<{ booking: BookingInfo }>());

export const setSendRefreshOffersEvent = createAction(
  '[AlternativeOffers] setSendRefreshOffersEvent',
  props<{ sendRefreshOffersEvent: boolean }>()
);

export const setAlternativeConfirmUrl = createAction(
  '[AlternativeOffers] setAlternativeConfirmUrl',
  props<{ url: string }>()
);

export const setOrderSummaryData = createAction(
  '[OrderSummaryActions] SetOrderSummary',
  props<{ data: FinnairOrder }>()
);

export const setOrderReset = createAction('[OrderSummaryActions] Reset');

export const setOrderStart = createAction('[OrderSummaryActions] LoadStart');

export const setOrderError = createAction('[OrderSummaryActions] LoadError');

export const setReviewConfirmed = createAction(
  '[AlternativeOffers] setReviewConfirmed',
  props<{ reviewConfirmed: boolean }>()
);

export const setAcknowledgeFlow = createAction(
  '[AlternativeOffers] setAcknowledgeFlow',
  props<{ acknowledgeFlow: boolean }>()
);

const _all = union({
  reset,
  setOffers,
  resetOffers,
  setDisruptedBoundIndex,
  setStatus,
  setSelectedOffer,
  resetSelectedOffers,
  setSelectedDate,
  setStage,
  setDeeplinkSource,
  resetDeeplinkSource,
  setConfirmationResponse,
  setSessionExpired,
  setBooking,
  setSessionStarted,
  setSendRefreshOffersEvent,
  setAlternativeConfirmUrl,
  setOrderSummaryData,
  setOrderReset,
  setOrderStart,
  setOrderError,
  setReviewConfirmed,
  setAcknowledgeFlow,
  setShowAlternativeOffers,
});
export type ActionsUnion = typeof _all;
